import React, { useContext, useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { auth, isHydrated } = useContext(AuthContext);
  const { username: requestedUsername } = useParams();

  // If authenticated, enforce username match when a :username param exists
  if (auth && auth.userId) {
    // First-access onboarding gate: users provisioned with a temporary account must
    // finish setting it up before using any authenticated route.
    if (auth.mustCompleteOnboarding) {
      return <Navigate to="/edit/complete-account" replace />;
    }
    if (
      requestedUsername &&
      (auth.username || "").toLowerCase() !== String(requestedUsername).toLowerCase()
    ) {
      // Mismatch: always redirect to the user's own dashboard per product rule
      return <Navigate to={`/edit/${auth.username}`} replace />;
    }
    return children;
  }

  // While auth hydration is in progress, hold rendering
  if (!isHydrated) {
    return null;
  }

  // After hydration attempt, still unauthenticated → redirect to login
  return <Navigate to="/edit/login" replace />;
};

export default ProtectedRoute;
